import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: '/',
    components: {
      login: resolve => require(['@/components/Login'], resolve)
    }
  }, {
    path: '/agreement',
    name: 'agreement',
    components: {
      agreement: resolve => require(['@/components/Agreement'], resolve)
    }
  }, {
    path: '/register',
    name: 'register',
    components: {
      login: resolve => require(['@/components/Register'], resolve)
    }
  }, {
    path: '/forget',
    name: 'forget',
    components: {
      login: resolve => require(['@/components/ForgetPassword'], resolve)
    }
  }, {
    path: '/bindphone',
    name: 'bindphone',
    components: {
      login: resolve => require(['@/components/BindPhone'], resolve)
    }
  },
    {
      path: '/weChatBinding',
      components: {
        agreement: resolve => require(['@/components/wechat'], resolve)
      }
    },
    {
      path: '/selRole',
      components: {
        wechat: resolve => require(['@/components/wxLogin'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js